import { createContext, useContext, type ReactNode } from "react";

import { NOOP_ERROR_REPORTER, type ErrorReporter } from "./sentry";

const ErrorReporterContext = createContext<ErrorReporter>(NOOP_ERROR_REPORTER);

export function ErrorReporterProvider({
  reporter,
  children,
}: {
  reporter: ErrorReporter;
  children: ReactNode;
}) {
  return (
    <ErrorReporterContext.Provider value={reporter}>{children}</ErrorReporterContext.Provider>
  );
}

export function useErrorReporter(): ErrorReporter {
  return useContext(ErrorReporterContext);
}
